export default ({teacherName}) => (<li style={{display:'block'}}>{teacherName}</li>)